export default function Bullet({ current, attractions, setSliderPos }) {
    return <div className="slider-bullet">
        {attractions.map((el, key) => {
            const classes = ['single-bullet'];
            if (key === current) classes.push('active')
            return <div className={classes.join(" ")} onClick={setSliderPos.bind(null, key)} key={key}></div>
        })}
    </div>
}